import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/Login.css'
import './assets/css/branding.css'
import './assets/css/responsive.css'
import './assets/css/Style.css'
import './assets/css/search.css'
import './assets/css/chat.css'
import './App.css'
import './style.scss'
import { BrowserRouter } from "react-router-dom";
import 'react-loading-skeleton/dist/skeleton.css'
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
